import { Controller } from "@hotwired/stimulus"

// Small top-bar dropdown: toggles on the button, closes on outside click,
// Escape, or choosing an item.
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
  }

  close() {
    this.panelTarget.hidden = true
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  handleShortcut(event) {
    if (event.key === "Escape") this.close()
  }
}
